import { useEffect, useRef } from 'react';
import { ModalShell } from '../../../components/PromptDialog';
/** ModalShell with keyboard containment, initial focus and focus restoration. */
export function PublishingDialog({
  title,
  submit,
  close,
  children,
}: {
  title: string;
  submit: () => void;
  close: () => void;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const onClose = useRef(close);
  onClose.current = close;
  useEffect(() => {
    const before = document.activeElement as HTMLElement | null;
    const nodes = () =>
      Array.from(
        ref.current?.querySelectorAll<HTMLElement>(
          'button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),a[href]',
        ) ?? [],
      );
    nodes()[0]?.focus();
    const key = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onClose.current();
      }
      if (event.key === 'Tab') {
        const all = nodes();
        const first = all[0];
        const last = all[all.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    };
    document.addEventListener('keydown', key);
    return () => {
      document.removeEventListener('keydown', key);
      before?.focus();
    };
  }, []);
  return (
    <div ref={ref}>
      <ModalShell
        title={title}
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        {children}
      </ModalShell>
    </div>
  );
}
